<template>
  <a-drawer width="60%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item :label="$t('商城头条.标题')" prop="title">
        <a-input v-model="form.title" :maxLength="255" :placeholder="$t('通用.输入.请输入') + $t('商城头条.标题')" />
      </a-form-model-item>

      <a-form-model-item :label="$t('商城头条.封面图')" prop="coverImage">
        <OssUploadSingle v-model="form.coverImage" type="img" :maxSize="200"></OssUploadSingle>
      </a-form-model-item>

      <a-form-model-item :label="$t('商城头条.所属分类')" prop="categoryId">
        <a-select v-model="form.categoryId" :placeholder="$t('通用.输入.请选择')" allowClear>
          <a-select-option v-for="(d, index) in dict.type['news_headline_category']" :key="index" :value="d.value">
            {{ d.label }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item :label="$t('商城头条.发布时间')" prop="publishTime">
        <a-date-picker
          v-model="form.publishTime"
          format="YYYY-MM-DD HH:mm:ss"
          :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
          :placeholder="$t('通用.输入.请选择')"
          style="width: 100%"
        />
      </a-form-model-item>

      <a-form-model-item :label="$t('商城头条.是否首页展示')" prop="isHomeShow">
        <a-switch :checked="form.isHomeShow === 1" @change="handleHomeShowChange" />
      </a-form-model-item>

      <a-form-model-item :label="$t('商城头条.排序')" prop="sort">
        <a-input-number v-model="form.sort" :min="0" :max="9999" style="width: 200px" />
      </a-form-model-item>

      <a-form-model-item :label="$t('商城头条.富文本详情')" prop="content">
        <editor v-model="form.content" :height="300" />
      </a-form-model-item>

      <a-form-model-item :label="$t('商城头条.备注')" prop="remark">
        <a-input v-model="form.remark" type="textarea" :rows="3" :maxLength="500" :placeholder="$t('通用.输入.请输入') + $t('商城头条.备注')" />
      </a-form-model-item>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('通用.按钮.保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('通用.按钮.取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getHeadline, addHeadline, updateHeadline } from '@/api/news/headline'
import OssUploadSingle from '@/components/OssUploadSingle'
import Editor from '@/components/Editor'
import moment from 'moment'

export default {
  name: 'CreateForm',
  components: {
    OssUploadSingle,
    Editor
  },
  dicts: ['news_headline_category'],
  props: {},
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,
        title: null,
        coverImage: null,
        content: null,
        publishTime: null,
        isHomeShow: 0,
        sort: 0,
        categoryId: null,
        remark: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        title: [{ required: true, message: this.$t('商城头条.标题') + this.$t('通用.文本.不能为空'), trigger: 'blur' }],
        coverImage: [{ required: true, message: this.$t('商城头条.封面图') + this.$t('通用.文本.不能为空'), trigger: 'blur' }]
      }
    }
  },
  created() {},
  methods: {
    moment,
    onClose() {
      this.open = false
      this.reset()
    },
    cancel() {
      this.open = false
      this.reset()
    },
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        title: null,
        coverImage: null,
        content: null,
        publishTime: null,
        isHomeShow: 0,
        sort: 0,
        categoryId: null,
        remark: null
      }
    },
    handleHomeShowChange(checked) {
      this.form.isHomeShow = checked ? 1 : 0
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset()
      this.formType = 2
      const id = row.id
      getHeadline({ id }).then(response => {
        this.form = response.data
        // 处理时间格式
        if (this.form.publishTime) {
          this.form.publishTime = moment(this.form.publishTime)
        }
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          const data = { ...this.form }
          // 处理时间格式
          if (data.publishTime) {
            data.publishTime = moment(data.publishTime).format('YYYY-MM-DD HH:mm:ss')
          }
          if (this.form.id !== undefined && this.form.id !== null) {
            updateHeadline(data)
              .then(() => {
                this.$message.success(this.$t('通用.文本.修改成功'))
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
              })
          } else {
            addHeadline(data)
              .then(() => {
                this.$message.success(this.$t('通用.文本.新增成功'))
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
              })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
::v-deep .adaptive {
  height: auto;
}
::v-deep .editor .w-e-text-container {
  height: 300px !important;
}
</style>
